import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import { ModelGhost } from "oc-jaco3d/arrangement/ModelGhost";
import { quat, v3 } from "oc-threejs/short3";
import * as Maths3 from "oc-threejs/Maths3";
import { getMMR } from "../RichMetadata";
import { MObjekt } from "../../metamodell";
import { PAuswahlwert, PObjekt, PPfosten } from "../../metamodell_paths";
import {
  filterPathIntersectionCached,
  findPathIntersectionCached,
  following_are_optionals,
} from "oc-app/metadata/GraphMetadata";
import { StücklistenIterator } from "./Stückliste";
import { Box3 } from "three";
import { ghostPool } from "./Arrangement";
import { Pfosten } from "./Pfosten";

export class Anker extends Jaco {
  static CLASS_NAME = "Anker";

  meta: MObjekt = null;
  model: ModelGhost = null;
  size = v3();
  box = new Box3();

  constructor(parent: Jaco) {
    super(parent);
  }

  traverse(iterator: any) {
    super.traverse(iterator);
    if (this.model) this.model.traverse(iterator);
  }

  getBox(): Box3 {
    return this.box.clone();
  }

  get pfosten(): Pfosten {
    return this.parent as Pfosten;
  }

  private updateBoxFromModel() {
    if (!this.model) {
      this.box.makeEmpty();
      this.size.set(0, 0, 0);
      return;
    }

    this.box.copy(this.model.getBox()).applyMatrix4(this.model.matrix);
    this.box.getSize(this.size);
  }

  update3d() {
    super.update3d();
    this.model = ghostPool(this).clearInstance(this.model);
    const anker = [
      ...filterPathIntersectionCached("Anker.js:39")(
        this.pfosten.meta,
        (p: PPfosten) => p.Sturmanker
      ),
      ...filterPathIntersectionCached("Anker.js:40")(
        this.pfosten.meta,
        (p: PPfosten) => p.Windanker
      ),
    ];
    this.meta = findPathIntersectionCached("Anker.js:37")(
      anker,
      (p: PObjekt) => p,
      following_are_optionals,
      this.pfosten.ankerAuswahlwert,
      (p: PAuswahlwert) => p.Objekt
    );

    const mmr = getMMR(this.meta);
    if (mmr == null) {
      debugger;
      getMMR(this.meta);
    }
    this.model = ghostPool(this).getForModelMaterialRelation(this, mmr, {
      size: v3(Infinity, Infinity, Infinity),
      fixGridPosition: v3(0, 0, 0),
    });
    this.model.update3d();
    this.updateAnkerPosition();
    this.updateBoxFromModel();
  }

  updateAnkerPosition() {
    const isSteckpfosten = this.pfosten.pfostenartAuswahlwert?.Key == "Steckpfosten";
    const isSturmanker = this.meta.Objekttyp == "Sturmanker";
    const { ankerInnen } = this.pfosten;
    // Eckpfosten haben kein einzelnes Segment, daher prüfen wir zuerst isPfostenAnEcke
    const flippedNormal = !this.pfosten.isPfostenAnEcke && this.pfosten.segment?.flippedNormal;
    const ausrichtungInnen = flippedNormal ? !ankerInnen : ankerInnen;
    ausrichtungInnen
      ? this.model.quaternion.copy(quat(0, 1, 0, 180)) && isSturmanker
        ? this.model.position.set(0.025, 0, isSteckpfosten ? -0.305 : -0.315)
        : this.model.position.set(0.025, 0, isSteckpfosten ? -0.18 : -0.19)
      : this.model.quaternion.copy(quat(0, 1, 0, 0)) && isSturmanker
        ? this.model.position.set(-0.025, 0, isSteckpfosten ? 0.305 : 0.315)
        : this.model.position.set(-0.025, 0, isSteckpfosten ? 0.18 : 0.19);

    this.model.update3d();
    this.updateBoxFromModel();
  }

  collectArtikel(iterator: StücklistenIterator, ObjectGroupTag?: string) {
    iterator({ ObjektMeta: this.meta, ObjectGroupTag, JacoId: this.id });
  }
}
